import { utils, write } from "xlsx";
import { saveAs } from "file-saver";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

function ExportExcel(Data, fileName = "") {
  const worksheet = utils.json_to_sheet(Data);
  const workbook = {
    Sheets: { data: worksheet },
    SheetNames: ["data"],
  };

  // Generar el buffer de Excel
  const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });

  // Guardar el archivo
  saveFile(excelBuffer, fileName);
}

function saveFile(buffer, fileName = "") {
  fileName = fileName === "" ? "data_export" : fileName;
  const file = new Blob([buffer], { type: EXCEL_TYPE });
  saveAs(file, `${fileName}${EXCEL_EXTENSION}`);
}

export { ExportExcel };
